import isBoolean from "lodash/isBoolean";

export function objectToFormData(obj: any) {
  const formData = new FormData();

  Object.keys(obj).forEach((key: string) => {
    const value: string | number | File | Blob = isBoolean(obj[key])
      ? Number(obj[key])
      : obj[key] !== null && obj[key] !== undefined
        ? obj[key]
        : "";

    if (Array.isArray(value)) {
      // Legacy and Next APIs expect "tags" as comma-separated IDs (e.g. "9,10,11"),
      // not JSON (e.g. "[9,10,11]"). Other arrays keep JSON format.
      if (key === "tags") {
        formData.append(key, value.map((v) => String(v)).join(","));
      } else {
        formData.append(key, JSON.stringify(value));
      }
    } else if (typeof value === "number") {
      formData.append(key, String(value));
    } else {
      formData.append(key, value as string | Blob);
    }
  });

  return formData;
}
